<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="lastName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="memberCardNo">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="email">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'memberNo'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'firstName'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'mobilePhone'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'expiresAfter'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'expiresBefore'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'membershipType'">
                <wbo-membership-type-multi-select-search-control></wbo-membership-type-multi-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'chargeAccountId'">
                <wbo-account-single-select-search-control></wbo-account-single-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'status'">
                <wbo-entity-availability-single-select-search-control></wbo-entity-availability-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column [allowDescendingSorting]="false" field="memberLastName"></wbo-main-search-column>
        <wbo-column [allowDescendingSorting]="false" field="memberFirstName"></wbo-column>
        <wbo-column [allowDescendingSorting]="false" field="email"></wbo-column>
        <wbo-column [sortable]="false" field="mobilePhone"></wbo-column>
        <wbo-column [sortable]="false" field="membershipType"></wbo-column>
        <wbo-column [allowDescendingSorting]="false" field="memberNo"></wbo-column>
        <wbo-column [allowDescendingSorting]="false" field="memberCardNo"></wbo-column>
        <wbo-date-column [allowDescendingSorting]="false" field="expiryDate"></wbo-date-column>
        <wbo-actions-search-column>
            <wbo-discontinue-search-action [availableCallback]="canDiscontinue"></wbo-discontinue-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
